// duplicate tab title inside content
const tabSliders = $( '.bs-tab-slider--duplicate-title' );
if ( tabSliders.length > 0 ) {
  const tabSlidersNav = tabSliders.find( '.bs-slider-tabs .slick-slide-wrapper' ),
    tabSlidersContent = tabSliders.find( '.bs-slider-content' );
  tabSlidersNav.each( ( index, nav ) => {
    const thisNav = $( nav ),
      thisTabTitle = thisNav.find( 'p, h3' ).html();
    tabSlidersContent
      .find( '.slick-slide-wrapper' )
      .eq( index )
      .prepend( `<p class="tab-title">${thisTabTitle.replace( /<br\s*\/?>/gi, ' ' )}</p>` );
  } );
}
